/**
 * Data hook for the Operations Under Review book surface.
 *
 *   useUnderReview() — polls GET /api/under-review every 15s. Read-only; the
 *   surface has no write path (shepherding happens in Airtable/portal).
 *
 * 15-second polling matches the rest of the app (no websockets in v1).
 * The list is bounded (the circulating population, ~tens of leads), so
 * refetching the whole thing is cheap.
 *
 * Spec: engineering/command-center/docs/port-notes/whirlpool.md (evicted 2026-08-29, #775 round 10)
 */

import { UnderReviewResponseSchema } from "@command-center/shared";
import { createPollingQuery } from "./create-polling-query";

export const useUnderReview = createPollingQuery({
  queryKey: ["under-review"] as const,
  path: "/api/under-review",
  schema: UnderReviewResponseSchema,
  refetchIntervalMs: 15_000,
});
